<template>
  <div class="app-container">
    <div class="filter-container">
      <!-- <el-input
          v-model="listQuery.keyword"
          placeholder="提现订单号"
          style="width: 200px"
          class="filter-item"
          clearable
      />
      <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >搜索</el-button
      > -->
      <el-button
        class="filter-item"
        type="primary"
        @click="handleAdd"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
        >新增</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        label="银行名称"
        align="center"
        prop="bankName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="支行名称"
        align="center"
        prop="branchName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="银行卡号"
        align="center"
        prop="bankAccount"
        width="200"
      ></el-table-column>
      <el-table-column
        label="开户名"
        align="center"
        prop="accountName"
      ></el-table-column>
      <el-table-column label="创建时间" align="center" prop="ctdate">
        <template slot-scope="scope">
          {{ scope.row.ctdate | parseTime }}
        </template></el-table-column
      >
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
        v-if="
          (isAgentLogin !== AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin !== AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
      >
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="onDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 引入新增弹窗组件 -->
    <PaymentMethodAdd
      v-if="dialogFormVisible"
      :dialog-visible="dialogFormVisible"
      @save="handleSave"
      @close="handleDialogClose"
    />
  </div>
</template>

<script>
import {
  queryWithdrawAccount,
  addWithdrawAccount,
  deleteWithdrawAccount,
} from "@/api/leve";
import PaymentMethodAdd from "./components/add.vue";
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";

export default {
  name: "withdrawalRecords",
  components: {
    PaymentMethodAdd,
  },
  props: {
    agentDetail: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      dialogFormVisible: false,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        pageSize: 10,
        keyword: "",
        status: "",
        createStart: "",
        createEnd: "",
      },
      agentUserId: "",
      isAgentLogin: "",
    };
  },
  filters: {
    parseTime(time) {
      const date = new Date(time);
      return date.toLocaleString("zh-CN");
    },
  },
  created() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.agentUserId =
      (this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT && this.disabled) ||
      this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        ? this.agentDetail?.agentUserId
        : getLogionUserInfo().agentUserId;
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.listQuery.agentUserId = this.agentUserId;
      queryWithdrawAccount(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.data?.totalCount;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    onDelete(row) {
      deleteWithdrawAccount({ id: row.id }).then(() => {
        this.getList();
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });
      });
      console.log(row);
    },
    handleAdd() {
      this.dialogFormVisible = true;
    },
    // 处理保存逻辑
    handleSave(formData) {
      this.listLoading = true;
      addWithdrawAccount(formData)
        .then(() => {
          this.dialogFormVisible = false;
          this.getList();
          this.$notify({
            title: "成功",
            message: "保存成功",
            type: "success",
            duration: 2000,
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 处理弹窗关闭逻辑
    handleDialogClose() {
      this.dialogFormVisible = false;
    },
    getStatus() {
      return "";
    },
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    },
  },
};
</script>

<style scoped lang="scss">
.pagination-container {
  float: none;
  text-align: end;
  margin: 20px 0 0;
}
</style>
